// for mobile view - bound to LA county
export const BOUNDS_SMALL = [
  -118.93083650093675, 34.95092952833262, -117.30845765713846,
  33.56550925111841,
];
// for desktop view - bound to LA county - WSEN
export const BOUNDS_LARGE = [
  -119.69058403564895, 34.8185484073039, -116.97570978225754, 33.68333042519106,
];

// from mapbox
export const STYLE = `mapbox://styles/latimes/clkslkixa00c201pmgqui5b0v${
  process.env.NODE_ENV === 'development' ? '/draft' : ''
}`;
//export const TILESET = 'mapbox://latimes.2hsvbd2s';
export const TILESET = 'mapbox://latimes.housing_tracker_2023_v3';

// this can be found on your tileset - on the right rail, look for "Vector layers" - there should be a name of the source layer right under that label
//export const SOURCE_LAYER = 'cities_trend-cknfq7';
export const SOURCE_LAYER = 'cities-trend';

// you can leave these as is or create a new source name if you want
export const SOURCE = 'source';
export const TOKEN =
  'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';
